// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
.pw-card {
  border-radius: 12px;
  background: #fff;
  border: 1px solid #ededed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.pw-mismatch {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #fffbeb 0%, #fff7ed 100%);
  border-bottom: 1px solid rgba(234, 88, 12, 0.15);
  font-size: 0.82rem;
}
.pw-mismatch-icon {
  font-size: 1.1rem;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 1px;
}
.pw-mismatch-title {
  font-weight: 700;
  color: #ea580c;
  margin-bottom: 2px;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.pw-mismatch-item {
  color: #171717;
  line-height: 1.4;
}
.pw-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);
  border-bottom: 1px solid rgba(22, 163, 74, 0.08);
}
.pw-sop-alerts .pw-sop-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 10px 16px;
  background: #fef2f2;
  border-bottom: 1px solid #ededed;
  color: #dc2626;
  font-size: 0.82rem;
  font-weight: 600;
}
.pw-source-tag {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #16a34a;
}
.pw-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  transition: transform 120ms ease, box-shadow 120ms ease;
}
.pw-status-badge:hover {
  transform: scale(1.04);
}
.pw-status-badge.status-active {
  background: #16a34a;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15);
}
.pw-status-badge.status-inactive {
  background: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);
}
.pw-status-badge.status-other {
  background: #a3a3a3;
}
.pw-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 16px;
}
.pw-hero-left {
  flex: 1;
  min-width: 0;
}
.pw-employer-name {
  font-size: 1.15rem;
  font-weight: 700;
  color: #171717;
  line-height: 1.3;
}
.pw-applicant-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 6px;
  font-size: 0.78rem;
  color: #a3a3a3;
}
.pw-name-match {
  font-size: 1rem;
  line-height: 1;
  margin-top: 2px;
}
.pw-match-yes {
  color: #16a34a;
}
.pw-match-no {
  color: #dc2626;
}
.pw-name-rows {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.pw-name-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
}
.pw-applicant-label {
  font-weight: 600;
  color: #a3a3a3;
  font-size: 0.72rem;
}
.pw-applicant-value {
  font-weight: 700;
  color: #171717;
  font-size: 0.82rem;
}
.pw-hero-right {
  flex-shrink: 0;
  text-align: right;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);
  border-radius: 6px;
  border: 1px solid rgba(22, 163, 74, 0.12);
}
.pw-hero-amount {
  font-size: 1.65rem;
  font-weight: 800;
  color: #16a34a;
  line-height: 1.1;
  letter-spacing: -0.02em;
}
.pw-hero-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-top: 1px;
}
.pw-hero-annual {
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #a3a3a3;
}
.pw-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  padding: 0 16px 14px;
}
.pw-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 120px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fafafa;
  margin: 3px;
  transition: background 120ms ease;
}
.pw-stat:hover {
  background: #f5f5f5;
}
.pw-stat-icon {
  font-size: 1.1rem;
  line-height: 1;
  flex-shrink: 0;
}
.pw-stat-body {
  min-width: 0;
}
.pw-stat-label {
  font-size: 0.62rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
}
.pw-stat-value {
  font-size: 0.82rem;
  font-weight: 700;
  color: #171717;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pw-stat-sub {
  font-size: 0.72rem;
  color: #a3a3a3;
  font-weight: 400;
}
.pw-capitalize {
  text-transform: capitalize;
}
.pw-stat-term .pw-stat-value {
  color: #dc2626;
}
.pw-more-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #005ff0;
  cursor: pointer;
  border-top: 1px solid #ededed;
  transition: background 120ms ease;
  -webkit-user-select: none;
          user-select: none;
}
.pw-more-toggle:hover {
  background: #fafafa;
}
.pw-toggle-chevron {
  display: inline-block;
  font-size: 0.7rem;
  transition: transform 200ms ease;
}
.pw-toggle-chevron.pw-toggle-open {
  transform: rotate(90deg);
}
.pw-more-body {
  padding: 14px 16px 16px;
  border-top: 1px solid #ededed;
  background: #fafafa;
}
.pw-detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}
.pw-detail-item {
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #ededed;
}
.pw-detail-item-label {
  font-size: 0.62rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-bottom: 2px;
}
.pw-detail-item-value {
  font-size: 0.88rem;
  font-weight: 700;
  color: #171717;
}
.pw-detail-item-value small {
  font-size: 0.7rem;
  font-weight: 400;
  color: #a3a3a3;
  margin-left: 2px;
}
.pw-paystubs {
  margin-top: 4px;
}
.pw-paystubs-title {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-bottom: 8px;
}
.pw-paystubs-meta {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}
.pw-stub-cards {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pw-stub-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #ededed;
  transition: background 120ms ease;
}
.pw-stub-card:hover {
  background: #f5f5f5;
}
.pw-stub-outlier {
  border-left: 3px solid #dc2626;
  background: #fefafa;
}
.pw-stub-period {
  font-size: 0.78rem;
  font-weight: 600;
  color: #171717;
  white-space: nowrap;
}
.pw-stub-amounts {
  display: flex;
  gap: 8px;
  align-items: baseline;
}
.pw-stub-gross {
  font-size: 0.85rem;
  font-weight: 700;
  color: #16a34a;
}
.pw-stub-net {
  font-size: 0.72rem;
  color: #a3a3a3;
}
.pw-stub-flags {
  display: flex;
  gap: 4px;
}
.pw-flag {
  display: inline-block;
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
}
.pw-flag-outlier {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}
.pw-flag-gap {
  background: rgba(234, 88, 12, 0.1);
  color: #ea580c;
}
.pw-stub-totals {
  display: flex;
  gap: 16px;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #ededed;
  font-size: 0.78rem;
  color: #a3a3a3;
}
.pw-stub-totals strong {
  color: #171717;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/payroll-wizard-detail.component.less"],"names":[],"mappings":"AAcA;EACE,cAAA;EACA,WAAA;AAbF;AAiBA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yEAAA;EACA,gBAAA;EACA,sBAAA;AAfF;AAmBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,6DAAA;EACA,gDAAA;EACA,kBAAA;AAjBF;AAoBA;EACE,iBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAlBF;AAqBA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AAnBF;AAsBA;EACE,cAAA;EACA,gBAAA;AApBF;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6DAAA;EACA,gDAAA;AAtBF;AA0BA;EAEI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAzBJ;AA6BA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AA3BF;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,uDAAA;AA5BF;AA8BE;EAAU,sBAAA;AA3BZ;AA4BE;EAAkB,mBAAA;EAA2B,6CAAA;AAxB/C;AAyBE;EAAoB,mBAAA;EAAyB,6CAAA;AArB/C;AAsBE;EAAiB,mBAAA;AAnBnB;AAuBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AArBF;AAwBA;EAAgB,OAAA;EAAS,YAAA;AApBzB;AAsBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AApBF;AAuBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AArBF;AAwBA;EAAiB,eAAA;EAAiB,cAAA;EAAgB,eAAA;AAnBlD;AAoBA;EAAgB,cAAA;AAjBhB;AAkBA;EAAe,cAAA;AAff;AAgBA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAXvD;AAYA;EAAe,aAAA;EAAe,qBAAA;EAAuB,QAAA;AAPrD;AAQA;EAAsB,gBAAA;EAAkB,cAAA;EAAwB,kBAAA;AAHhE;AAIA;EAAsB,gBAAA;EAAkB,cAAA;EAAyB,kBAAA;AACjE;AACA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;EACA,kBAAA;EACA,yCAAA;AACF;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAAF;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AADF;AAIA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAFF;AAMA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,oBAAA;AAJF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,iCAAA;AALF;AAOE;EAAU,mBAAA;AAJZ;AAOA;EAAgB,iBAAA;EAAmB,cAAA;EAAgB,cAAA;AAFnD;AAIA;EAAgB,YAAA;AADhB;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AADF;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;AAKA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAHF;AAMA;EAAiB,0BAAA;AAHjB;AAKA;EAA+B,cAAA;AAF/B;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,iCAAA;EACA,yBAAA;UAAA,iBAAA;AAHF;AAKE;EAAU,mBAAA;AAFZ;AAKA;EACE,qBAAA;EACA,iBAAA;EACA,gCAAA;AAHF;AAKE;EAAmB,wBAAA;AAFrB;AAKA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;AAHF;AAOA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,mBAAA;AALF;AAQA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AANF;AASA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAPF;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AARF;AAKA;EAMI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AARJ;AAaA;EAAe,eAAA;AAVf;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAVF;AAaA;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;AAXF;AAcA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAZF;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iCAAA;AAbF;AAeE;EAAU,mBAAA;AAZZ;AAeA;EACE,8BAAA;EACA,mBAAA;AAbF;AAgBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAdF;AAiBA;EACE,aAAA;EACA,QAAA;EACA,qBAAA;AAfF;AAkBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAhBF;AAmBA;EACE,kBAAA;EACA,cAAA;AAjBF;AAoBA;EACE,aAAA;EACA,QAAA;AAlBF;AAqBA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAnBF;AAsBA;EAAmB,kCAAA;EAAoC,cAAA;AAlBvD;AAmBA;EAAe,kCAAA;EAAoC,cAAA;AAfnD;AAiBA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAfF;AAMA;EAWW,cAAA;AAdX","sourcesContent":["// UDS-inspired tokens\n@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-orange-70: #ea580c;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host {\n  display: block;\n  width: 100%;\n}\n\n// ── Card shell ──\n.pw-card {\n  border-radius: @uds-radius;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);\n  overflow: hidden;\n  margin-bottom: 0.75rem;\n}\n\n// ── Identity mismatch ──\n.pw-mismatch {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #fffbeb 0%, #fff7ed 100%);\n  border-bottom: 1px solid rgba(234, 88, 12, 0.15);\n  font-size: 0.82rem;\n}\n\n.pw-mismatch-icon {\n  font-size: 1.1rem;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.pw-mismatch-title {\n  font-weight: 700;\n  color: @uds-orange-70;\n  margin-bottom: 2px;\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.pw-mismatch-item {\n  color: @uds-neutral-100;\n  line-height: 1.4;\n}\n\n// ── Header band ──\n.pw-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);\n  border-bottom: 1px solid rgba(22, 163, 74, 0.08);\n}\n\n// ── SOP alert banners ──\n.pw-sop-alerts {\n  .pw-sop-alert {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    padding: 10px 16px;\n    background: #fef2f2;\n    border-bottom: 1px solid @uds-neutral-30;\n    color: @uds-red-70;\n    font-size: 0.82rem;\n    font-weight: 600;\n  }\n}\n\n.pw-source-tag {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: @uds-green-70;\n}\n\n.pw-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #fff;\n  transition: transform @uds-ease, box-shadow @uds-ease;\n\n  &:hover { transform: scale(1.04); }\n  &.status-active { background: @uds-green-70; box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15); }\n  &.status-inactive { background: @uds-red-70; box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12); }\n  &.status-other { background: @uds-neutral-50; }\n}\n\n// ── Hero section ──\n.pw-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 16px;\n}\n\n.pw-hero-left { flex: 1; min-width: 0; }\n\n.pw-employer-name {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  line-height: 1.3;\n}\n\n.pw-applicant-line {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 6px;\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n}\n\n.pw-name-match { font-size: 1rem; line-height: 1; margin-top: 2px; }\n.pw-match-yes { color: @uds-green-70; }\n.pw-match-no { color: @uds-red-70; }\n.pw-name-rows { display: flex; flex-direction: column; gap: 1px; }\n.pw-name-row { display: flex; align-items: baseline; gap: 5px; }\n.pw-applicant-label { font-weight: 600; color: @uds-neutral-50; font-size: 0.72rem; }\n.pw-applicant-value { font-weight: 700; color: @uds-neutral-100; font-size: 0.82rem; }\n\n.pw-hero-right {\n  flex-shrink: 0;\n  text-align: right;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);\n  border-radius: @uds-radius-sm;\n  border: 1px solid rgba(22, 163, 74, 0.12);\n}\n\n.pw-hero-amount {\n  font-size: 1.65rem;\n  font-weight: 800;\n  color: @uds-green-70;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.pw-hero-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-top: 1px;\n}\n\n.pw-hero-annual {\n  margin-top: 4px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: @uds-neutral-50;\n}\n\n// ── Stats row ──\n.pw-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  padding: 0 16px 14px;\n}\n\n.pw-stat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 auto;\n  min-width: 120px;\n  padding: 8px 12px;\n  border-radius: @uds-radius-sm;\n  background: @uds-neutral-10;\n  margin: 3px;\n  transition: background @uds-ease;\n\n  &:hover { background: @uds-neutral-20; }\n}\n\n.pw-stat-icon { font-size: 1.1rem; line-height: 1; flex-shrink: 0; }\n\n.pw-stat-body { min-width: 0; }\n\n.pw-stat-label {\n  font-size: 0.62rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n}\n\n.pw-stat-value {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pw-stat-sub {\n  font-size: 0.72rem;\n  color: @uds-neutral-50;\n  font-weight: 400;\n}\n\n.pw-capitalize { text-transform: capitalize; }\n\n.pw-stat-term .pw-stat-value { color: @uds-red-70; }\n\n// ── Expandable detail ──\n.pw-more-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 16px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: @uds-blue-70;\n  cursor: pointer;\n  border-top: 1px solid @uds-neutral-30;\n  transition: background @uds-ease;\n  user-select: none;\n\n  &:hover { background: @uds-neutral-10; }\n}\n\n.pw-toggle-chevron {\n  display: inline-block;\n  font-size: 0.7rem;\n  transition: transform 200ms ease;\n\n  &.pw-toggle-open { transform: rotate(90deg); }\n}\n\n.pw-more-body {\n  padding: 14px 16px 16px;\n  border-top: 1px solid @uds-neutral-30;\n  background: @uds-neutral-10;\n}\n\n// ── Detail grid ──\n.pw-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.pw-detail-item {\n  padding: 8px 10px;\n  border-radius: @uds-radius-sm;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n}\n\n.pw-detail-item-label {\n  font-size: 0.62rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-bottom: 2px;\n}\n\n.pw-detail-item-value {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n\n  small {\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: @uds-neutral-50;\n    margin-left: 2px;\n  }\n}\n\n// ── Paystub cards ──\n.pw-paystubs { margin-top: 4px; }\n\n.pw-paystubs-title {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-bottom: 8px;\n}\n\n.pw-paystubs-meta {\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.pw-stub-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pw-stub-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: @uds-radius-sm;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  transition: background @uds-ease;\n\n  &:hover { background: @uds-neutral-20; }\n}\n\n.pw-stub-outlier {\n  border-left: 3px solid @uds-red-70;\n  background: #fefafa;\n}\n\n.pw-stub-period {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: @uds-neutral-100;\n  white-space: nowrap;\n}\n\n.pw-stub-amounts {\n  display: flex;\n  gap: 8px;\n  align-items: baseline;\n}\n\n.pw-stub-gross {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: @uds-green-70;\n}\n\n.pw-stub-net {\n  font-size: 0.72rem;\n  color: @uds-neutral-50;\n}\n\n.pw-stub-flags {\n  display: flex;\n  gap: 4px;\n}\n\n.pw-flag {\n  display: inline-block;\n  font-size: 0.6rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.pw-flag-outlier { background: rgba(220, 38, 38, 0.1); color: @uds-red-70; }\n.pw-flag-gap { background: rgba(234, 88, 12, 0.1); color: @uds-orange-70; }\n\n.pw-stub-totals {\n  display: flex;\n  gap: 16px;\n  margin-top: 8px;\n  padding: 8px 12px;\n  border-radius: @uds-radius-sm;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n\n  strong { color: @uds-neutral-100; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
